<template>
  <div class="content blacklist">
    <div class="header">
      <el-button type="primary" size="small" @click="dialogFormVisible = true">排班设置</el-button>
    </div>
    <template>
      <el-table :data="tableData" style="width: 100%" size="small" :header-cell-style="setTableHeader">
        <el-table-column prop="sort" label="#" width="180"></el-table-column>
        <el-table-column prop="sort" label="班次"></el-table-column>
        <el-table-column prop="des" label="上班时间"></el-table-column>
        <el-table-column prop="des" label="上班周期"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text">编辑</el-button>
            <el-button type="text" @click="deleteRow(scope.$index, scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <!--  添加关键词 -->
    <el-dialog title="排班设置" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="员工" :label-width="formLabelWidth">
          <el-select v-model="form.name" multiple  placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上班时间" :label-width="formLabelWidth">
          <el-date-picker
            v-model="form.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="班次" :label-width="formLabelWidth">
          <el-select v-model="form.name" multiple  placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      page_id: "",
      tableData: [],
      dialogFormVisible: false,
      form: {
        name: [],
        time: '',
        class: '',
      },
      formLabelWidth: '120px',
      options: [
        {
          value: '选项1',
          label: '员工1'
        },
        {
          value: '选项2',
          label: '员工2'
        },
      ],
      options2: [
        {
          value: '选项1',
          label: '1'
        },
        {
          value: '选项2',
          label: '2'
        },
      ]
    };
  },
  mounted() {
    this.page_id = this.$route.params.id;
  },

};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  // box-shadow: 0 0 3px #f1f1f1;
}
.blacklist {
  padding: 10px 25px;
  .header {
    border-bottom: 0;
    position: relative;
    padding-left: 24px;
    margin-bottom: 15px;
    padding: 10px 15px;
  }
  .img {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    img {
      width: 80%;
    }
  }
}
</style>